import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useMemo, useState } from "react";

export const useAuthTokenProvider = () => {
  const queryClient = useQueryClient();

  const [token, setToken] = useState<null | string>(
    localStorage.getItem("token"),
  );

  const authenticate = useCallback(
    (token: string) => {
      setToken(token);
      localStorage.setItem("token", token);
      queryClient.invalidateQueries({ queryKey: ["user"] });
    },
    [queryClient],
  );

  const logout = useCallback(() => {
    setToken(null);
    queryClient.invalidateQueries();
    localStorage.removeItem("token");
  }, [queryClient]);

  return useMemo(
    () => ({
      authenticate,
      logout,
      token,
    }),
    [token, authenticate, logout],
  );
};
